export class MobileBffGetUnreadNotificationsRequest {
  unreadCount!: number;
}
